export interface NotFoundProps {
  message: string
}

export const useNotFound = (props: NotFoundProps) => {
  return {
    ...props,
  }
}
